import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      UserLogin: 'UserLogin',
      docFontSize:'fontSize'
    })
  },
  methods: {
    ...mapMutations({
      SETDATA: 'UserLogin/SETDATA',
      SETADMINID: 'UserLogin/SETADMINID',
      SETOPTIONS: 'UserLogin/SETOPTIONS',
      setLeftMenuShow_M:"SET_LEFTMENU_SHOW"
    }),
    ...mapActions({
      getCaptchaBase64: 'UserLogin/getCaptchaBase64',
      sendLogin: 'UserLogin/sendLogin',
      sendPasRes: 'UserLogin/sendPasRes',
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/UserLogin/components/Mixins.js